import { mapDTO } from '@twistezo/ts-dto-mapper'

import { SortInput } from 'components/Table'
import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import { DomainAlert } from 'features/inventory/domain/types/DomainAlert'
import { DomainPrebidModuleSchemaParameter } from 'features/inventory/domain/types/domainPrebidModule'
import { DomainPrebidModuleAlert } from 'features/inventory/domain/types/domainPrebidModuleAlert'
import { DomainPrebidModuleSlice, DomainPrebidModuleSortBy } from '../types'
import { DomainPrebidModuleSliceDTO, DomainPrebidModuleSortByDTO } from './types'
import { mergeParamsWithSchema, paramsSchemaFromDTO } from './utils'

export const domainPrebidModulesFromDTO = (
  from: DomainPrebidModuleSliceDTO,
): DomainPrebidModuleSlice =>
  mapDTO<DomainPrebidModuleSliceDTO, DomainPrebidModuleSlice>({ from }).transform(
    (data: DomainPrebidModuleSliceDTO): DomainPrebidModuleSlice => {
      const {
        domain: { activeAbTest, alerts: domainAlerts, name },
        enabled,
        fieldAlerts,
        id,
        params,
        paramsSchema: paramsSchemaDTO,
        updatedAt,
      } = data

      const paramsSchema: DomainPrebidModuleSchemaParameter[] = paramsSchemaFromDTO(paramsSchemaDTO)

      return {
        alerts: alertsFromDTO<DomainPrebidModuleAlert>(fieldAlerts),
        domain: {
          activeAbTest: activeAbTest ?? undefined,
          alerts: alertsFromDTO<DomainAlert>(domainAlerts),
          name,
        },
        enabled,
        id,
        params: mergeParamsWithSchema(params, paramsSchema),
        paramsSchema,
        updatedAt: new Date(updatedAt),
      }
    },
  )

export const sortToDTO = (
  sort: SortInput<DomainPrebidModuleSortBy>,
): SortInput<DomainPrebidModuleSortByDTO> => {
  const { by } = sort

  if (by === 'domain.name') {
    return { ...sort, by: 'domainName' }
  } else {
    return { ...sort, by }
  }
}
